/**
 * L'app scrive «-» e non «—». Le notifiche salvate prima del cambio conservano
 * il loro testo: si normalizzano alla lettura, invece di riscrivere le righe
 * di tutte le CER nel database.
 */
export function plainDashes(text: string): string {
	return text.replaceAll('—', '-');
}

/** Titolo e messaggio di una notifica letta dal database, con «-» al posto di «—». */
export function withPlainDashes<T extends { titolo?: unknown; messaggio?: unknown }>(row: T): T {
	return {
		...row,
		...(typeof row.titolo === 'string' ? { titolo: plainDashes(row.titolo) } : {}),
		...(typeof row.messaggio === 'string' ? { messaggio: plainDashes(row.messaggio) } : {}),
	};
}
